import { makeStyles } from '@rbx/ui';

const useContentTableRowStyles = makeStyles()((theme) => ({
  row: {
    verticalAlign: 'top',
    borderBottom: `1px solid ${theme.palette.components.divider}`,
    'p, a, span:not(.MuiChip-label)': {
      fontSize: '16px',
      '& code, & pre, & .inline-code, & [class*="inlineCode"] a': {
        fontSize: '14px',
      },
    },
    '&:hover > div': {
      backgroundColor: theme.palette.states.hover,
    },
  },

  name: {
    flexGrow: 1,
    padding: 16,
    backgroundColor: theme.palette.background.snackbar,
    wordBreak: 'break-word',
  },

  nameCol2: {
    flexGrow: 0,
    maxWidth: '30%',
    flexBasis: '30%',
  },

  nameCol3: {
    flexGrow: 0,
    maxWidth: '25%',
    flexBasis: '25%',
  },

  empty: {
    padding: 0,
  },

  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
  },
}));

export default useContentTableRowStyles;
